package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class SignSymptomAssociatedFactorName(private val literal: String) : IEnumType {
	揉按拍打("揉按拍打"),
	春天("春天"),
	夏天("夏天"),
	秋天("秋天"),
	冬天("冬天"),
	温热环境("温热环境"),
	寒冷环境("寒冷环境"),
	月经正来("月经正来"),
	产后("产后"),
	饮食生冷食品("饮食生冷食品"),
	饮食油腻食品("饮食油腻食品"),
	饮食煎炒烘焙食品("饮食煎炒烘焙食品"),
	饮食海鲜("饮食海鲜"),
	饮食寒凉食品("饮食寒凉食品"),
	饮食热燥食品("饮食热燥食品");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "sign_symptom_associated_factor_name"}
	override fun getLiteral(): String {return literal}
}
